// Values here are overwritten at runtime by ConfigService loading /assets/config.json.
// For local development, set real values in src/assets/config.json (gitignored).
export const environment = {
  production: false,
  api: {
    url: "",
    serviceurl: "",
    downloadAllUrl: "",
    getParcelUrl: "",
    uploadUrl: "",
    msgUrl: "",
    elasticSearch: "",
  },
  googleApiKey: "",
  googleTagManagerId: "",
};
